import { createReducer } from "redux-act";

import * as actions from "../../actions";

const initial_state = {
	open: false
};

export const uiMenu = createReducer({}, initial_state);

uiMenu.on(actions.uiMenu.openHamburgerMenu, state => ({
	...state,
	open: true
}));

uiMenu.on(actions.uiMenu.closeHamburgerMenu, state => ({
	...state,
	open: false
}));


// WEBPACK FOOTER //
// ./src/modules/reducers/uiMenu/index.js